<h1 class="learner pl-4 pt-4">Offsite LMS Certificates</h1>
<div class="content-container">
  <mrt-grid-template [gridOptions]="gridOptions" (actionEvent)="actionEvent($event)"></mrt-grid-template>
</div>